enum ThemeName {
  HALLOWEEN = "halloween",
  BLACK_FRIDAY = "black friday",
}

export type ThemeVariant = "default" | "halloween" | "blackFriday";

export const useThemePattern = (theme: string): ThemeVariant => {
  switch (theme) {
    case ThemeName.HALLOWEEN:
      return "halloween";
    case ThemeName.BLACK_FRIDAY:
      return "blackFriday";
    default:
      return "default";
  }
};
